// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SaveFilledSvg from "@fishx/icons-svg/es/asn/SaveFilled";
import FishxIcon from '../components/FishxIcon';

var SaveFilled = function SaveFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SaveFilledSvg
  }));
};

SaveFilled.displayName = 'SaveFilled';
export default React.forwardRef(SaveFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SaveFilled.js
// module id = 4060
// module chunks = 0